import { render, staticRenderFns } from "./MembershipWebhooksForm.vue?vue&type=template&id=8da82890&"
import script from "./MembershipWebhooksForm.vue?vue&type=script&lang=js&"
export * from "./MembershipWebhooksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports